import React from "react";
import { useOutletContext } from "react-router-dom";

// img
// import qrCodeImg from "../assets/png/qr-code.png";

// Jds
import { Button, Container, Text } from "@jds/core";

// Mui
import { Box } from "@mui/material";

// Local
import { baseToImg } from "../util/helper";

export default function QrcodePage() {
  const [eventDetails] = useOutletContext();

  const downloadImage = (base64String) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" }); // Adjust the MIME type if needed

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${eventDetails.name}_qr.png`; // Set the desired filename
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <Container horizontalAlign="space-between" fullWidth>
        <Container direction="column" gap={14}>
          <Text text="QR Code" appearance="heading-xs" />
          <Text
            text="Scan QR code for Exclusive Access"
            color="primary_grey_80"
            appearance="body-m-bold"
          />
        </Container>
        <Button
          iconLeft={"IcDownload"}
          label="Download"
          onClick={() => {
            downloadImage(eventDetails?.qrCodeImage);
          }}
        />
      </Container>
      <Container
        fullWidth
        horizontalAlign="center"
        style={{ marginTop: "48px" }}
      >
        <Box maxWidth={360} textAlign={"center"}>
          <img src={baseToImg(eventDetails?.qrCodeImage)} alt="qr code" />
          {/* <img src={eventDetails?.qrCodeImage} alt="qr code" /> */}
        </Box>
      </Container>
    </>
  );
}
